import { Directive } from '@angular/core';
import { RxTextareaComponent } from './rx-textarea.component';

@Directive({
	selector: '[rxTextareaCancel]',
	standalone: true,
	host: {
		'(click)': 'onClick()'
	}
})
export class RxTextareaCancelDirective {
	constructor(private readonly textarea: RxTextareaComponent) {}

	onClick(): void {
		this.textarea.cancel();
	}
}
